import clsx from 'clsx';

export const fetchTemplates = ({
  templatesOnly,
  questionnaireOnly,
  search,
  isPagare,
  page,
  nolimit
} = {}) => ({
  method: 'GET',
  url: clsx(
    '/templates/all?',
    nolimit && `nolimit=${nolimit}`,
    page && `page=${page}`,
    templatesOnly && 'templatesOnly=true',
    questionnaireOnly && 'questionnaireOnly=true',
    search && `search=${search}`,
    isPagare && 'pagareOnly=true'
  ).split(' ').join('&')
});

export const fetchTemplate = templateId => ({
  method: 'GET',
  url: `/templates/${templateId}`
});

export const templateAction = (templateId, action, data, parameters = {}) => ({
  method: 'POST',
  url: `/templates/${templateId}/${action}`,
  data,
  ...parameters
});

export const updateTemplate = ({
  templateId,
  ...data
}) => ({
  method: 'PUT',
  url: `/templates/${templateId}`,
  data
});
export const createFromQuestionnaire = (data) => ({
  method: 'PUT',
  url: `/templates/questionnaire/${data._id}`,
  data
})

export const createContractFromTemplate = (data) => ({
  method: 'PUT',
  url: `/templates/contract/${data._id}`,
  data
})

export const calculateQuestionsVariables = (templateId) => ({
  method: 'POST',
  url: `/templates/${templateId}/calculate-questions-variables`,
})

export const fetchTemplatesFavourites = () => ({
  method: 'GET',
  url: '/templates/favourites',
})

export const bulkDeleteTemplates = (data) => ({
  method: 'POST',
  url: '/templates/bulk/remove',
  data
})

export const createTemplate = (data) => ({
  method: 'POST',
  url: '/templates',
  data
})

export const createMassive = (data) => ({
  method: 'POST',
  url: `/templates/massive/${data._id}`,
  data
})

export const duplicateTemplate = (data) => ({
  method: 'POST',
  url: `/templates/duplicate/${data._id}`,
  data
})
